;(function nfPremiumReplicasMenuFallback(){
  var href = '/collections/premium-replica-katana';
  var label = 'Premium Replicas';
  var anchorSelector = 'a[href="/collections/other-game-movie-katana"],a[href*="/collections/other-game-movie-katana"]';

  function hasPremiumLink(group) {
    return Boolean(group && group.querySelector('a[href="' + href + '"],a[href*="' + href + '"]'));
  }

  function isMenuGroup(group) {
    if (!group) return false;
    if (group.id === 'content_drop_anime') return true;
    return Boolean(group.closest('#content_drop_anime,.t4s-sub-menu,.t4s-drawer-menu,.t4s-mb-nav,.t4s-menu-drawer,.t4s-push-menu'));
  }

  function buildMenuItem(reference) {
    var item = reference.cloneNode(false);
    var link = document.createElement('a');
    link.href = href;
    link.textContent = label;
    item.appendChild(link);
    return item;
  }

  function addLinkAfter(referenceLink) {
    var referenceItem = referenceLink.closest('.t4s-menu-item,li');
    if (!referenceItem || !referenceItem.parentNode) return;
    var group = referenceItem.parentNode;
    if (!isMenuGroup(group) || hasPremiumLink(group)) return;
    referenceItem.insertAdjacentElement('afterend', buildMenuItem(referenceItem));
  }

  function run() {
    document.querySelectorAll(anchorSelector).forEach(addLinkAfter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.setTimeout(run, 700);
  window.setTimeout(run, 1800);
  if (window.MutationObserver) {
    new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
